import AnimatedLink from './AnimatedLink'


export default AnimatedLink
